/**
 * Country reference data shared across features (onboarding wizard, chatbot,
 * college counselling). Lifted from the chatbot's CountrySelect so non-chatbot
 * screens don't have to import across page trees.
 */

export interface CountryOption {
  /** Display name, e.g. 'Pakistan'. */
  label: string
  /** Stored value — same as the display name (no ISO codes are persisted). */
  value: string
  /** Flag emoji. */
  icon: string
}

export const COUNTRIES: CountryOption[] = [
  {label: 'Pakistan', value: 'Pakistan', icon: '🇵🇰'},
  {label: 'Afghanistan', value: 'Afghanistan', icon: '🇦🇫'},
  {label: 'Albania', value: 'Albania', icon: '🇦🇱'},
  {label: 'Algeria', value: 'Algeria', icon: '🇩🇿'},
  {label: 'Andorra', value: 'Andorra', icon: '🇦🇩'},
  {label: 'Angola', value: 'Angola', icon: '🇦🇴'},
  {label: 'Antigua and Barbuda', value: 'Antigua and Barbuda', icon: '🇦🇬'},
  {label: 'Argentina', value: 'Argentina', icon: '🇦🇷'},
  {label: 'Armenia', value: 'Armenia', icon: '🇦🇲'},
  {label: 'Australia', value: 'Australia', icon: '🇦🇺'},
  {label: 'Austria', value: 'Austria', icon: '🇦🇹'},
  {label: 'Azerbaijan', value: 'Azerbaijan', icon: '🇦🇿'},
  {label: 'Bahamas', value: 'Bahamas', icon: '🇧🇸'},
  {label: 'Bahrain', value: 'Bahrain', icon: '🇧🇭'},
  {label: 'Bangladesh', value: 'Bangladesh', icon: '🇧🇩'},
  {label: 'Barbados', value: 'Barbados', icon: '🇧🇧'},
  {label: 'Belarus', value: 'Belarus', icon: '🇧🇾'},
  {label: 'Belgium', value: 'Belgium', icon: '🇧🇪'},
  {label: 'Belize', value: 'Belize', icon: '🇧🇿'},
  {label: 'Benin', value: 'Benin', icon: '🇧🇯'},
  {label: 'Bhutan', value: 'Bhutan', icon: '🇧🇹'},
  {label: 'Bolivia', value: 'Bolivia', icon: '🇧🇴'},
  {label: 'Bosnia and Herzegovina', value: 'Bosnia and Herzegovina', icon: '🇧🇦'},
  {label: 'Botswana', value: 'Botswana', icon: '🇧🇼'},
  {label: 'Brazil', value: 'Brazil', icon: '🇧🇷'},
  {label: 'Brunei', value: 'Brunei', icon: '🇧🇳'},
  {label: 'Bulgaria', value: 'Bulgaria', icon: '🇧🇬'},
  {label: 'Burkina Faso', value: 'Burkina Faso', icon: '🇧🇫'},
  {label: 'Burundi', value: 'Burundi', icon: '🇧🇮'},
  {label: 'Cambodia', value: 'Cambodia', icon: '🇰🇭'},
  {label: 'Cameroon', value: 'Cameroon', icon: '🇨🇲'},
  {label: 'Canada', value: 'Canada', icon: '🇨🇦'},
  {label: 'Cape Verde', value: 'Cape Verde', icon: '🇨🇻'},
  {label: 'Central African Republic', value: 'Central African Republic', icon: '🇨🇫'},
  {label: 'Chad', value: 'Chad', icon: '🇹🇩'},
  {label: 'Chile', value: 'Chile', icon: '🇨🇱'},
  {label: 'China', value: 'China', icon: '🇨🇳'},
  {label: 'Colombia', value: 'Colombia', icon: '🇨🇴'},
  {label: 'Comoros', value: 'Comoros', icon: '🇰🇲'},
  {label: 'Congo', value: 'Congo', icon: '🇨🇬'},
  {label: 'Costa Rica', value: 'Costa Rica', icon: '🇨🇷'},
  {label: 'Croatia', value: 'Croatia', icon: '🇭🇷'},
  {label: 'Cuba', value: 'Cuba', icon: '🇨🇺'},
  {label: 'Cyprus', value: 'Cyprus', icon: '🇨🇾'},
  {label: 'Czech Republic', value: 'Czech Republic', icon: '🇨🇿'},
  {label: 'Denmark', value: 'Denmark', icon: '🇩🇰'},
  {label: 'Djibouti', value: 'Djibouti', icon: '🇩🇯'},
  {label: 'Dominica', value: 'Dominica', icon: '🇩🇲'},
  {label: 'Dominican Republic', value: 'Dominican Republic', icon: '🇩🇴'},
  {label: 'Ecuador', value: 'Ecuador', icon: '🇪🇨'},
  {label: 'Egypt', value: 'Egypt', icon: '🇪🇬'},
  {label: 'El Salvador', value: 'El Salvador', icon: '🇸🇻'},
  {label: 'Equatorial Guinea', value: 'Equatorial Guinea', icon: '🇬🇶'},
  {label: 'Eritrea', value: 'Eritrea', icon: '🇪🇷'},
  {label: 'Estonia', value: 'Estonia', icon: '🇪🇪'},
  {label: 'Ethiopia', value: 'Ethiopia', icon: '🇪🇹'},
  {label: 'Fiji', value: 'Fiji', icon: '🇫🇯'},
  {label: 'Finland', value: 'Finland', icon: '🇫🇮'},
  {label: 'France', value: 'France', icon: '🇫🇷'},
  {label: 'Gabon', value: 'Gabon', icon: '🇬🇦'},
  {label: 'Gambia', value: 'Gambia', icon: '🇬🇲'},
  {label: 'Georgia', value: 'Georgia', icon: '🇬🇪'},
  {label: 'Germany', value: 'Germany', icon: '🇩🇪'},
  {label: 'Ghana', value: 'Ghana', icon: '🇬🇭'},
  {label: 'Greece', value: 'Greece', icon: '🇬🇷'},
  {label: 'Grenada', value: 'Grenada', icon: '🇬🇩'},
  {label: 'Guatemala', value: 'Guatemala', icon: '🇬🇹'},
  {label: 'Guinea', value: 'Guinea', icon: '🇬🇳'},
  {label: 'Guinea-Bissau', value: 'Guinea-Bissau', icon: '🇬🇼'},
  {label: 'Guyana', value: 'Guyana', icon: '🇬🇾'},
  {label: 'Haiti', value: 'Haiti', icon: '🇭🇹'},
  {label: 'Honduras', value: 'Honduras', icon: '🇭🇳'},
  {label: 'Hungary', value: 'Hungary', icon: '🇭🇺'},
  {label: 'Iceland', value: 'Iceland', icon: '🇮🇸'},
  {label: 'India', value: 'India', icon: '🇮🇳'},
  {label: 'Indonesia', value: 'Indonesia', icon: '🇮🇩'},
  {label: 'Iran', value: 'Iran', icon: '🇮🇷'},
  {label: 'Iraq', value: 'Iraq', icon: '🇮🇶'},
  {label: 'Ireland', value: 'Ireland', icon: '🇮🇪'},
  {label: 'Israel', value: 'Israel', icon: '🇮🇱'},
  {label: 'Italy', value: 'Italy', icon: '🇮🇹'},
  {label: 'Jamaica', value: 'Jamaica', icon: '🇯🇲'},
  {label: 'Japan', value: 'Japan', icon: '🇯🇵'},
  {label: 'Jordan', value: 'Jordan', icon: '🇯🇴'},
  {label: 'Kazakhstan', value: 'Kazakhstan', icon: '🇰🇿'},
  {label: 'Kenya', value: 'Kenya', icon: '🇰🇪'},
  {label: 'Kiribati', value: 'Kiribati', icon: '🇰🇮'},
  {label: 'Kuwait', value: 'Kuwait', icon: '🇰🇼'},
  {label: 'Kyrgyzstan', value: 'Kyrgyzstan', icon: '🇰🇬'},
  {label: 'Laos', value: 'Laos', icon: '🇱🇦'},
  {label: 'Latvia', value: 'Latvia', icon: '🇱🇻'},
  {label: 'Lebanon', value: 'Lebanon', icon: '🇱🇧'},
  {label: 'Lesotho', value: 'Lesotho', icon: '🇱🇸'},
  {label: 'Liberia', value: 'Liberia', icon: '🇱🇷'},
  {label: 'Libya', value: 'Libya', icon: '🇱🇾'},
  {label: 'Liechtenstein', value: 'Liechtenstein', icon: '🇱🇮'},
  {label: 'Lithuania', value: 'Lithuania', icon: '🇱🇹'},
  {label: 'Luxembourg', value: 'Luxembourg', icon: '🇱🇺'},
  {label: 'Madagascar', value: 'Madagascar', icon: '🇲🇬'},
  {label: 'Malawi', value: 'Malawi', icon: '🇲🇼'},
  {label: 'Malaysia', value: 'Malaysia', icon: '🇲🇾'},
  {label: 'Maldives', value: 'Maldives', icon: '🇲🇻'},
  {label: 'Mali', value: 'Mali', icon: '🇲🇱'},
  {label: 'Malta', value: 'Malta', icon: '🇲🇹'},
  {label: 'Marshall Islands', value: 'Marshall Islands', icon: '🇲🇭'},
  {label: 'Mauritania', value: 'Mauritania', icon: '🇲🇷'},
  {label: 'Mauritius', value: 'Mauritius', icon: '🇲🇺'},
  {label: 'Mexico', value: 'Mexico', icon: '🇲🇽'},
  {label: 'Micronesia', value: 'Micronesia', icon: '🇫🇲'},
  {label: 'Moldova', value: 'Moldova', icon: '🇲🇩'},
  {label: 'Monaco', value: 'Monaco', icon: '🇲🇨'},
  {label: 'Mongolia', value: 'Mongolia', icon: '🇲🇳'},
  {label: 'Montenegro', value: 'Montenegro', icon: '🇲🇪'},
  {label: 'Morocco', value: 'Morocco', icon: '🇲🇦'},
  {label: 'Mozambique', value: 'Mozambique', icon: '🇲🇿'},
  {label: 'Myanmar', value: 'Myanmar', icon: '🇲🇲'},
  {label: 'Namibia', value: 'Namibia', icon: '🇳🇦'},
  {label: 'Nauru', value: 'Nauru', icon: '🇳🇷'},
  {label: 'Nepal', value: 'Nepal', icon: '🇳🇵'},
  {label: 'Netherlands', value: 'Netherlands', icon: '🇳🇱'},
  {label: 'New Zealand', value: 'New Zealand', icon: '🇳🇿'},
  {label: 'Nicaragua', value: 'Nicaragua', icon: '🇳🇮'},
  {label: 'Niger', value: 'Niger', icon: '🇳🇪'},
  {label: 'Nigeria', value: 'Nigeria', icon: '🇳🇬'},
  {label: 'North Korea', value: 'North Korea', icon: '🇰🇵'},
  {label: 'North Macedonia', value: 'North Macedonia', icon: '🇲🇰'},
  {label: 'Norway', value: 'Norway', icon: '🇳🇴'},
  {label: 'Oman', value: 'Oman', icon: '🇴🇲'},
  {label: 'Palau', value: 'Palau', icon: '🇵🇼'},
  {label: 'Palestine', value: 'Palestine', icon: '🇵🇸'},
  {label: 'Panama', value: 'Panama', icon: '🇵🇦'},
  {label: 'Papua New Guinea', value: 'Papua New Guinea', icon: '🇵🇬'},
  {label: 'Paraguay', value: 'Paraguay', icon: '🇵🇾'},
  {label: 'Peru', value: 'Peru', icon: '🇵🇪'},
  {label: 'Philippines', value: 'Philippines', icon: '🇵🇭'},
  {label: 'Poland', value: 'Poland', icon: '🇵🇱'},
  {label: 'Portugal', value: 'Portugal', icon: '🇵🇹'},
  {label: 'Qatar', value: 'Qatar', icon: '🇶🇦'},
  {label: 'Romania', value: 'Romania', icon: '🇷🇴'},
  {label: 'Russia', value: 'Russia', icon: '🇷🇺'},
  {label: 'Rwanda', value: 'Rwanda', icon: '🇷🇼'},
  {label: 'Saint Kitts and Nevis', value: 'Saint Kitts and Nevis', icon: '🇰🇳'},
  {label: 'Saint Lucia', value: 'Saint Lucia', icon: '🇱🇨'},
  {
    label: 'Saint Vincent and the Grenadines',
    value: 'Saint Vincent and the Grenadines',
    icon: '🇻🇨',
  },
  {label: 'Samoa', value: 'Samoa', icon: '🇼🇸'},
  {label: 'San Marino', value: 'San Marino', icon: '🇸🇲'},
  {label: 'Sao Tome and Principe', value: 'Sao Tome and Principe', icon: '🇸🇹'},
  {label: 'Saudi Arabia', value: 'Saudi Arabia', icon: '🇸🇦'},
  {label: 'Senegal', value: 'Senegal', icon: '🇸🇳'},
  {label: 'Serbia', value: 'Serbia', icon: '🇷🇸'},
  {label: 'Seychelles', value: 'Seychelles', icon: '🇸🇨'},
  {label: 'Sierra Leone', value: 'Sierra Leone', icon: '🇸🇱'},
  {label: 'Singapore', value: 'Singapore', icon: '🇸🇬'},
  {label: 'Slovakia', value: 'Slovakia', icon: '🇸🇰'},
  {label: 'Slovenia', value: 'Slovenia', icon: '🇸🇮'},
  {label: 'Solomon Islands', value: 'Solomon Islands', icon: '🇸🇧'},
  {label: 'Somalia', value: 'Somalia', icon: '🇸🇴'},
  {label: 'South Africa', value: 'South Africa', icon: '🇿🇦'},
  {label: 'South Korea', value: 'South Korea', icon: '🇰🇷'},
  {label: 'South Sudan', value: 'South Sudan', icon: '🇸🇸'},
  {label: 'Spain', value: 'Spain', icon: '🇪🇸'},
  {label: 'Sri Lanka', value: 'Sri Lanka', icon: '🇱🇰'},
  {label: 'Sudan', value: 'Sudan', icon: '🇸🇩'},
  {label: 'Suriname', value: 'Suriname', icon: '🇸🇷'},
  {label: 'Sweden', value: 'Sweden', icon: '🇸🇪'},
  {label: 'Switzerland', value: 'Switzerland', icon: '🇨🇭'},
  {label: 'Syria', value: 'Syria', icon: '🇸🇾'},
  {label: 'Taiwan', value: 'Taiwan', icon: '🇹🇼'},
  {label: 'Tajikistan', value: 'Tajikistan', icon: '🇹🇯'},
  {label: 'Tanzania', value: 'Tanzania', icon: '🇹🇿'},
  {label: 'Thailand', value: 'Thailand', icon: '🇹🇭'},
  {label: 'Timor-Leste', value: 'Timor-Leste', icon: '🇹🇱'},
  {label: 'Togo', value: 'Togo', icon: '🇹🇬'},
  {label: 'Tonga', value: 'Tonga', icon: '🇹🇴'},
  {label: 'Trinidad and Tobago', value: 'Trinidad and Tobago', icon: '🇹🇹'},
  {label: 'Tunisia', value: 'Tunisia', icon: '🇹🇳'},
  {label: 'Turkey', value: 'Turkey', icon: '🇹🇷'},
  {label: 'Turkmenistan', value: 'Turkmenistan', icon: '🇹🇲'},
  {label: 'Tuvalu', value: 'Tuvalu', icon: '🇹🇻'},
  {label: 'Uganda', value: 'Uganda', icon: '🇺🇬'},
  {label: 'Ukraine', value: 'Ukraine', icon: '🇺🇦'},
  {label: 'United Arab Emirates', value: 'United Arab Emirates', icon: '🇦🇪'},
  {label: 'United Kingdom', value: 'United Kingdom', icon: '🇬🇧'},
  {label: 'United States', value: 'United States', icon: '🇺🇸'},
  {label: 'Uruguay', value: 'Uruguay', icon: '🇺🇾'},
  {label: 'Uzbekistan', value: 'Uzbekistan', icon: '🇺🇿'},
  {label: 'Vanuatu', value: 'Vanuatu', icon: '🇻🇺'},
  {label: 'Vatican City', value: 'Vatican City', icon: '🇻🇦'},
  {label: 'Venezuela', value: 'Venezuela', icon: '🇻🇪'},
  {label: 'Vietnam', value: 'Vietnam', icon: '🇻🇳'},
  {label: 'Yemen', value: 'Yemen', icon: '🇾🇪'},
  {label: 'Zambia', value: 'Zambia', icon: '🇿🇲'},
  {label: 'Zimbabwe', value: 'Zimbabwe', icon: '🇿🇼'},
]

/** ISO 3166-1 alpha-2 code -> country display name. */
export const COUNTRY_CODES: Record<string, string> = {
  PK: 'Pakistan',
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AD: 'Andorra',
  AO: 'Angola',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BA: 'Bosnia and Herzegovina',
  BW: 'Botswana',
  BR: 'Brazil',
  BN: 'Brunei',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  CV: 'Cape Verde',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CO: 'Colombia',
  KM: 'Comoros',
  CG: 'Congo',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CY: 'Cyprus',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  ET: 'Ethiopia',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GR: 'Greece',
  GD: 'Grenada',
  GT: 'Guatemala',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  HN: 'Honduras',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Ireland',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MR: 'Mauritania',
  MU: 'Mauritius',
  MX: 'Mexico',
  FM: 'Micronesia',
  MD: 'Moldova',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  KP: 'North Korea',
  MK: 'North Macedonia',
  NO: 'Norway',
  OM: 'Oman',
  PW: 'Palau',
  PS: 'Palestine',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PL: 'Poland',
  PT: 'Portugal',
  QA: 'Qatar',
  RO: 'Romania',
  RU: 'Russia',
  RW: 'Rwanda',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  KR: 'South Korea',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syria',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VA: 'Vatican City',
  VE: 'Venezuela',
  VN: 'Vietnam',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
}

const COUNTRY_NAMES = new Set(COUNTRIES.map((c) => c.value.toLowerCase()))

/** Resolve a raw value (display name or ISO alpha-2 code) to a known country name. */
export const resolveCountryName = (raw: unknown): string | null => {
  if (typeof raw !== 'string') return null
  const trimmed = raw.trim()
  if (!trimmed) return null
  const byCode = COUNTRY_CODES[trimmed.toUpperCase()]
  if (byCode) return byCode
  if (COUNTRY_NAMES.has(trimmed.toLowerCase())) {
    return COUNTRIES.find((c) => c.value.toLowerCase() === trimmed.toLowerCase())!.value
  }
  return null
}

/** Object keys under which tenant records have been seen to carry a country. */
const COUNTRY_FIELD_CANDIDATES = ['country', 'country_name', 'countryName', 'country_code']

/**
 * Best-effort default country: first a country-ish field on any of the given
 * account objects (user profile, general settings), then the browser locale's
 * region. Returns null when nothing resolves — callers should treat that as
 * "ask the user".
 */
export const detectDefaultCountry = (
  ...accountObjects: Array<Record<string, any> | null | undefined>
): string | null => {
  for (const obj of accountObjects) {
    if (!obj) continue
    for (const field of COUNTRY_FIELD_CANDIDATES) {
      const resolved = resolveCountryName(obj[field])
      if (resolved) return resolved
    }
  }
  try {
    for (const tag of navigator.languages ?? [navigator.language]) {
      // 'en-PK' carries an explicit region; maximize() also infers one from
      // bare language tags (e.g. 'ur' -> PK), which is the desired fallback.
      const region = new Intl.Locale(tag).maximize().region
      const resolved = resolveCountryName(region)
      if (resolved) return resolved
    }
  } catch {
    // Older browsers without Intl.Locale — fall through to null.
  }
  return null
}

/* Flag SVGs ship at public/media/flags/<kebab-cased name>.svg; a few files use
   different names, and Cyprus/Guyana have no bundled asset at all. */
const FLAG_FILE_ALIASES: Record<string, string> = {
  Congo: 'republic-of-the-congo',
  'Marshall Islands': 'marshall-island',
  'North Macedonia': 'republic-of-macedonia',
  'Saint Lucia': 'st-lucia',
  'Sao Tome and Principe': 'sao-tome-and-prince',
  'Timor-Leste': 'east-timor',
}
const COUNTRIES_WITHOUT_FLAG_ASSET = new Set(['Cyprus', 'Guyana'])

/**
 * Relative path (for toAbsoluteUrl) of the bundled flag SVG for a country
 * display name, or null when no asset ships. Preferred over the emoji icons,
 * which Windows renders as bare letter pairs ("PK") instead of flags.
 */
export const countryFlagPath = (name: string): string | null => {
  if (COUNTRIES_WITHOUT_FLAG_ASSET.has(name)) return null
  const file = FLAG_FILE_ALIASES[name] ?? name.toLowerCase().replace(/[^a-z0-9]+/g, '-')
  return `media/flags/${file}.svg`
}
